import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@carrier/utils/Api';

export const fetchVendors = createAsyncThunk(
  'vendors/fetchVendors',
  async (params, { getState, rejectWithValue }) => {
    try {
      const { page = 1, search = '', forceRefresh = false } = params || {};
      const cacheKey = `${page}_${search}`;
      const { vendorsCache } = getState().vendors;

      if (vendorsCache[cacheKey] && !forceRefresh) {
        return { ...vendorsCache[cacheKey], cacheKey, currentPage: page, searchQuery: search };
      }

      const apiParams = { page, name: search };

      const { data, headers } = await Api.loadVendors(apiParams);
      const pagination = headers['x-pagination'] ? JSON.parse(headers['x-pagination']) : {};

      return { data, pagination, cacheKey, currentPage: page, searchQuery: search };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch vendors');
    }
  }
);

const initialState = {
  vendors: [],
  vendorsCache: {},
  pagination: {},
  loading: false,
  error: null,
  currentPage: 1,
  searchQuery: ''
};

const vendorSlice = createSlice({
  name: 'vendors',
  initialState,
  reducers: {
    clearCache: state => {
      state.vendorsCache = {};
    },

    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchVendors.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        const { data, pagination, cacheKey, currentPage, searchQuery } = action.payload;

        state.vendorsCache[cacheKey] = { data, pagination };
        state.vendors = data;
        state.pagination = pagination;
        state.currentPage = currentPage;
        state.searchQuery = searchQuery;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch vendors';
      });
  }
});

export const { clearCache, setSearchQuery, setCurrentPage } = vendorSlice.actions;
export default vendorSlice.reducer;
